const state = () => ({
  title: null,
  content: null,
  alias: null,
  type: null,
  page: null,
  id: null,
  isBookmark: false,
  pageData: null,
  watchlist: null,
  load: false,
  ussbTrackerData: null,
  relatedContent: null,
  banners: null,
  polls: null,
  pollsData: [],
});

const getters = {
  getLocation: (state) => {
    if (
      state.pageData &&
      state.pageData.field_current_location &&
      state.pageData.field_current_location.length
    ) {
      return state.pageData.field_current_location[0].value;
    }
  },
  getOrderedList: (state) => {
    if (state.watchlist && state.pageData) {
      const keys = [
        {
          label: "Company",
          name: "field_company",
          options: [],
        },
        {
          label: "Specialism",
          name: "field_specialism",
          options: [],
        },
        {
          label: "Sector",
          name: "field_sector",
          options: [],
        },
        {
          label: "Jurisdiction",
          name: "field_jurisdiction",
          options: [],
        },
      ];
      if (state.watchlist.field_company) {
        for (const key in state.watchlist.field_company.options) {
          if (
            state.pageData.field_companies &&
            state.pageData.field_companies.some((el2) => el2.target_id === key)
          ) {
            const item = keys.find((el) => el.name === "field_company");
            item.options.push(state.watchlist.field_company.options[key]);
            item.value = state.watchlist.field_company.value;
          }
        }
      }
      if (state.watchlist.field_jurisdiction) {
        if (state.pageData.field_one_jurisdiction) {
          for (const key in state.watchlist.field_jurisdiction.options) {
            if (
              state.pageData.field_one_jurisdiction &&
              state.pageData.field_one_jurisdiction.some(
                (el2) => el2.target_id === key
              )
            ) {
              const item = keys.find((el) => el.name === "field_jurisdiction");
              item.options.push(
                state.watchlist.field_jurisdiction.options[key]
              );
              item.value = state.watchlist.field_jurisdiction.value;
            }
          }
        } else if (state.pageData.field_jurisdiction) {
          for (const key in state.watchlist.field_jurisdiction.options) {
            if (
              state.pageData.field_jurisdiction &&
              state.pageData.field_jurisdiction.some(
                (el2) => el2.target_id === key
              )
            ) {
              const item = keys.find((el) => el.name === "field_jurisdiction");
              item.options.push(
                state.watchlist.field_jurisdiction.options[key]
              );
              item.value = state.watchlist.field_jurisdiction.value;
            }
          }
        }
      }
      if (state.watchlist.field_sector) {
        for (const key in state.watchlist.field_sector.options) {
          if (
            state.pageData.field_sector &&
            state.pageData.field_sector.some((el2) => el2.target_id === key)
          ) {
            const item = keys.find((el) => el.name === "field_sector");
            item.options.push(state.watchlist.field_sector.options[key]);
            item.value = state.watchlist.field_sector.value;
          }
        }
      }
      if (state.watchlist.field_specialism) {
        for (const key in state.watchlist.field_specialism.options) {
          if (
            state.pageData.field_specialism &&
            state.pageData.field_specialism.some((el2) => el2.target_id === key)
          ) {
            const item = keys.find((el) => el.name === "field_specialism");
            item.options.push(state.watchlist.field_specialism.options[key]);
            item.value = state.watchlist.field_specialism.value;
          }
        }
      }
      return keys;
    }
  },
  getRelated: (state) => {
    let arr = [];
    if (
      state.pageData &&
      state.pageData.include &&
      state.pageData.include.field_related_content
    ) {
      const relatedObj = state.pageData.include.field_related_content;
      for (const key in relatedObj) {
        const productAccess = [];
        if (
          relatedObj[key].field_product &&
          relatedObj[key].field_product.length
        ) {
          relatedObj[key].field_product.forEach((el) => {
            productAccess.push(el.target_id + "");
          });
        }
        const terms = [];
        if (
          relatedObj[key] &&
          relatedObj[key].include &&
          relatedObj[key].include.field_jurisdiction
        ) {
          for (const key2 in relatedObj[key].include.field_jurisdiction) {
            terms.push({
              name: relatedObj[key].include.field_jurisdiction[key2].name[0]
                .value,
              view_taxonomy_term:
                relatedObj[key].include.field_jurisdiction[key2].tid[0].value +
                "",
            });
          }
        }

        if (
          relatedObj[key] &&
          relatedObj[key].include &&
          relatedObj[key].include.field_sector
        ) {
          for (const key2 in relatedObj[key].include.field_sector) {
            terms.push({
              name: relatedObj[key].include.field_sector[key2].name[0].value,
              view_taxonomy_term:
                relatedObj[key].include.field_sector[key2].tid[0].value + "",
            });
          }
        }

        if (
          relatedObj[key] &&
          relatedObj[key].include &&
          relatedObj[key].include.field_specialism
        ) {
          for (const key2 in relatedObj[key].include.field_specialism) {
            terms.push({
              name: relatedObj[key].include.field_specialism[key2].name[0]
                .value,
              view_taxonomy_term:
                relatedObj[key].include.field_specialism[key2].tid[0].value +
                "",
            });
          }
        }

        arr.push({
          title: relatedObj[key].title[0].value,
          body: relatedObj[key].body[0].value,
          summary: relatedObj[key].body[0].summary,
          created:
            relatedObj[key].field_date_pub &&
            relatedObj[key].field_date_pub.length
              ? relatedObj[key].field_date_pub[0].value
              : relatedObj[key].created[0].value,
          link: relatedObj[key].path[0].alias
            ? relatedObj[key].path[0].alias
            : "/node/" + relatedObj[key].nid[0].value,
          product_access: productAccess,
          terms,
        });
      }
      arr = arr.filter((el, idx) => idx < 6);
    }
    if (arr.length < 6 && state.relatedContent && state.relatedContent.length) {
      arr = arr.concat(state.relatedContent);
    }
    return arr;
  },
  getAccordion: (state) => {
    if (
      state.pageData &&
      state.pageData.include &&
      state.pageData.field_accordion &&
      state.pageData.field_accordion.length
    ) {
      const arr = [];
      state.pageData.field_accordion.forEach((el) => {
        arr.push(state.pageData.include.field_accordion[el.target_id]);
      });
      const newArr = JSON.parse(JSON.stringify(arr));
      if (newArr.length) {
        newArr.forEach((el) => {
          if (el.field_sub_section && el.field_sub_section.length) {
            el.sub = [];
            el.field_sub_section.forEach((el2) => {
              el.sub.push(el.include.field_sub_section[el2.target_id]);
            });
          }
        });
      }
      return newArr;
    }
  },
  getTerms: (state) => {
    if (state.pageData && state.pageData.include) {
      const terms = [];

      if (state.pageData.include.field_jurisdiction) {
        for (const key in state.pageData.include.field_jurisdiction) {
          terms.push({
            name: state.pageData.include.field_jurisdiction[key].name[0].value,
            view_taxonomy_term:
              state.pageData.include.field_jurisdiction[key].tid[0].value,
          });
        }
      }

      if (state.pageData.include.field_one_jurisdiction) {
        for (const key in state.pageData.include.field_one_jurisdiction) {
          terms.push({
            name: state.pageData.include.field_one_jurisdiction[key].name[0]
              .value,
            view_taxonomy_term:
              state.pageData.include.field_one_jurisdiction[key].tid[0].value,
          });
        }
      }

      if (state.pageData.include.field_sector) {
        for (const key in state.pageData.include.field_sector) {
          terms.push({
            name: state.pageData.include.field_sector[key].name[0].value,
            view_taxonomy_term:
              state.pageData.include.field_sector[key].tid[0].value,
          });
        }
      }

      if (state.pageData.include.field_specialism) {
        for (const key in state.pageData.include.field_specialism) {
          terms.push({
            name: state.pageData.include.field_specialism[key].name[0].value,
            view_taxonomy_term:
              state.pageData.include.field_specialism[key].tid[0].value,
          });
        }
      }

      return terms;
    }
  },
  getAuthorName: (state) => {
    if (
      state.pageData &&
      state.pageData.include &&
      state.pageData.field_authors &&
      state.pageData.field_authors.length
    ) {
      let names = "";
      let allNames = "";
      state.pageData.field_authors.forEach((el) => {
        allNames =
          allNames +
          state.pageData.include.field_authors[el.target_id].title[0].value +
          ", ";
      });
      names = allNames.slice(0, -2);
      return names;
    }
  },
  getAuthorMail: (state) => {
    if (
      state.pageData &&
      state.pageData.include &&
      state.pageData.include.field_authors
    ) {
      const arr = [];
      for (const key in state.pageData.include.field_authors) {
        const item = state.pageData.include.field_authors[key].field_email;
        arr.push(item && item.length ? item[0].value : null);
      }
      if (arr.length) return arr[0];
    }
  },
  getLibrary: (state) => {
    const arr = [];
    let country = null;
    if (
      state.pageData &&
      state.pageData.include &&
      state.pageData.include.field_jurisdiction
    ) {
      country = state.pageData.include.field_jurisdiction;
    } else if (
      state.pageData &&
      state.pageData.include &&
      state.pageData.include.field_one_jurisdiction
    ) {
      country = state.pageData.include.field_one_jurisdiction;
    }
    if (country) {
      for (const key in country) {
        if (
          country[key].include &&
          country[key].include.field_reference_library
        ) {
          for (const key2 in country[key].include.field_reference_library) {
            const item = country[key].include.field_reference_library[key2];
            arr.push({
              title: item.field_title[0].value,
              url: item.field_plain_url.length
                ? item.field_plain_url[0].value
                : null,
              update_date: item.field_update_date.length
                ? item.field_update_date[0].value
                : null,
            });
          }
        }
      }
    } else if (
      state.pageData &&
      state.pageData.include &&
      state.pageData.include.field_reference_library
    ) {
      const library = state.pageData.include.field_reference_library;
      const libraryArr = state.pageData.field_reference_library;
      libraryArr.forEach((el) => {
        const key = el.target_id;
        arr.push({
          update_date: library[key].field_update_date.length
            ? library[key].field_update_date[0].value
            : null,
          title: library[key].field_title[0].value,
          url: library[key].field_plain_url[0].value,
        });
      });
    }
    return arr.filter((el, index) => index < 16);
  },
  getCurrency: (state) => {
    if (
      state.pageData.field_fine_or_penalty_currency &&
      state.pageData.field_fine_or_penalty_currency.length
    ) {
      const currency = state.pageData.field_fine_or_penalty_currency[0].value;
      if (currency === "GBP") {
        return "£";
      } else if (currency === "USD") {
        return "$";
      } else if (currency === "Euro") {
        return "€";
      } else {
        return currency;
      }
    }
  },
  getReference: (state) => {
    const arr = [];
    if (
      state.pageData &&
      state.pageData.include &&
      state.pageData.include.field_reference_library
    ) {
      const obj = state.pageData.include.field_reference_library;
      for (const key in obj) {
        arr.push({
          name: obj[key].field_title[0].value,
          link: obj[key].field_plain_url.length
            ? obj[key].field_plain_url[0].value
            : "",
        });
      }
    }
    return arr;
  },
  getFile: (state) => {
    return state.pageData &&
      state.pageData.include.field_file &&
      state.pageData.include.field_file.length
      ? state.pageData.include.field_file[0].src
      : "";
  },
  getTitle: (state) => {
    return state.title ? state.title : "";
  },
};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
    if (data.label === "pageData") {
      state.title = data.data.title;
    }
  },
  setTitle(state, data) {
    state.title = data;
  },
  setPolls(state, data) {
    if (
      !(
        state.pollsData.length &&
        state.pollsData.some((el) => el.id === data.id)
      )
    ) {
      state.pollsData.push(data);
    }
  },
};

const actions = {
  async getPolls({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then(({ data }) => {
        commit("setPolls", data);
      })
      .catch(({ response }) => {
        // console.log(response, url);
      });
  },
  async getApi({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((response) => response)
      .catch((response) => response);
  },

  async getBase({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((response) => response)
      .catch((response) => response);
  },
  async getData({ commit, state }, { url, data, label }) {
    const body = {
      method: "GET",
      data,
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => {
        commit("setData", { label, data: data.data });
        return data;
      })
      .catch((response) => {
        console.error(response, url);
        return response;
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
